// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1209":"bb911f22","8486":"2e910fec"}[chunkId] + ".chunk.css";
};